import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const SearchIcon = (props: IconProps) => (
  <Icon height="20px" width="20px" viewBox="0 0 20 20" {...props}>
    <path d="M13.13 11.88h-.66l-.232-.226a5.393 5.393 0 001.308-3.525 5.417 5.417 0 10-5.417 5.417 5.393 5.393 0 003.525-1.308l.225.233v.658l4.167 4.159 1.242-1.242-4.159-4.167zm-5 0a3.745 3.745 0 01-3.75-3.75 3.745 3.745 0 013.75-3.75 3.745 3.745 0 013.75 3.75 3.745 3.745 0 01-3.75 3.75z" />
  </Icon>
);

export default memo(SearchIcon);
